/*
  A little helper to check if the current environment is the Flocknote mobile app
*/

export function isMobileApp() {
  try {
    return document.querySelector("html").classList.contains("isApp");
  } catch (e) {
    return false;
  }
}
